// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Controlled.Layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  position: relative;
  height: 100%;
}
div.Controlled.Layout > div.LayoutColumn.Controlled {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  padding: 0 10px;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Layout/Layout.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,qBAAA;MAAA,iBAAA;EACA,kBAAA;EACA,YAAA;AACF;AACE;EACE,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,eAAA;EACA,kBAAA;AACJ","sourcesContent":["div.Controlled.Layout {\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n  height: 100%;\n\n  > div.LayoutColumn.Controlled {\n    flex: 1;\n    padding: 0 10px;\n    position: relative;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
